export default __webpack_public_path__ + "static/media/hero.87ad5f1e.png";